import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Constant } from '../constant';

var jsonResponse: any;
@Injectable({
  providedIn: 'root'
})
export class ContactInformationVipService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient, private constant: Constant) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    this.httpOptions.headers = headers;
  }

  getContactInformationVip(): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/contact-information-vip', this.httpOptions);
  }

  getContactInformationVipById(id): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/contact-information-vip/' + id, this.httpOptions);
  }

  updateContactInformationVip(id, department): Observable<any> {
    return this.http.put<any>(this.constant.API_ENDPOINT + '/contact-information-vip/' + id, JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  addContactInformationVip(department): Observable<any> {
    return this.http.post<any>(this.constant.API_ENDPOINT + '/contact-information-vip', JSON.stringify(department),
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  deleteContactInformationVip(id): Observable<any> {
    return this.http.patch<any>(this.constant.API_ENDPOINT + '/contact-information-vip/' + id, {},
    this.httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  sendEmail(id): Observable<any> {
    return this.http.get<any>(this.constant.API_ENDPOINT + '/contact-information-vip/send-email/' + id, this.httpOptions);
  }

  // Error handling
  handleError(error) {
  console.log(error);
  let errorMessage = '';
  if(error.error && error.error.data) {
    errorMessage = error.error.data.error_message;
  }
  return throwError(errorMessage);
  }
}